module.exports = __webpack_public_path__ + "static/media/preview_live.d27dd636.png";